const products = {
    state: {
        filters: {},
        products: [],
        loading: 0
    },
    getters: {
        loading: state => state.loading > 0
    },
    mutations: {
        startLoading: state => state.loading++,
        resetLoading: state => (state.loading = 0),
        finishLoading: state => setTimeout(() => (state.loading > 0 ? state.loading-- : state.loading), 300),
        updateFilters(state, payload) {
            state.filters = Object.assign(state.filters, payload);
        },
        setProducts(state, payload) {
            state.products = payload;
        },
        setInitialFilters(state) {
            state.filters = {
                ...state.filters,
                ...{
                    storeCategory: null,
                    category: null,
                    subcategories: [],
                    vendors: [],
                    price: [null, null],
                    rating: [],
                    available: false,
                    discounts: [],
                    quantity: false
                }
            };
        },
        setInitialHeaderFilters(state, { sortName, limitName }) {
            state.filters = {
                ...state.filters,
                ...{
                    sort: { value: '-created_at', name: sortName },
                    limit: { name: limitName, value: 25 },
                    term: ''
                }
            };
        }
    }
};

export default products;
